import React from "react";
import { Button, Menu, Layout, Typography, Card, Row, Col } from "antd";
import {
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  QrcodeOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const FooterLayout = () => {
  return (
    <Footer className="footer">
      <div className="footer-left">
        <img src={require("../../assets/logo.png")} alt="logo" />
        <Paragraph>
          Easily convert Word, Excel, and PowerPoint to PDF with Bonoxi.
          Generate and scan QR codes quickly and efficiently. Simple, fast, and
          reliable PDF and QR solutions.
        </Paragraph>
        <Paragraph type="secondary">
          Copyright © Bonoxi 2024. All rights reserved.
        </Paragraph>
      </div>
      <div className="footer-right">
        <Title level={5}>BONOXI</Title>
        <ul>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms">Terms & Conditions</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
    </Footer>
  );
};

export default FooterLayout;
